module.exports = __webpack_public_path__ + "img/ico-copy.9790fdb8.svg";